import React from 'react';
import PropTypes from 'prop-types';
import CollapsableRow from '../../../../collapsableRow/CollapsableRow';
import Icon, { IconSizes } from '../../../../components/foundations/Icon';
import SuggestionItem from './SuggestionItem';
import css from './SuggestionsSection.css';
import withTranslate from '../../../../containers/widgets/withTranslate';
import { INSIGHTS_KEY_PREFIX } from '../consts';

const SuggestionsSection = ({ suggestions, expandedCategory, onCategoryClick, translate }) => {
    if (!suggestions) return null;

    const CREATIVE_FEEDBACK = 'creative_feedback';

    return (
        <CollapsableRow
            onClick={() => onCategoryClick(CREATIVE_FEEDBACK)}
            expanded={expandedCategory === CREATIVE_FEEDBACK}
            title={
                <div className={css.titleContainer}>
                    <Icon name="sparkles" size={IconSizes.MEDIUM} className={css.icon4} interactive={false} />
                    <span className={css.title}>{translate(`${INSIGHTS_KEY_PREFIX}.SUGGESTIONS`)}</span>
                </div>
            }
        >
            <div className={css.insightContainer}>
                <div>
                    {suggestions.map((suggestion, index) => (
                        <SuggestionItem key={`suggestion-${index}`} creativeData={suggestion} index={index} />
                    ))}
                </div>
            </div>
        </CollapsableRow>
    );
};

SuggestionsSection.propTypes = {
    suggestions: PropTypes.array,
    expandedCategory: PropTypes.string,
    onCategoryClick: PropTypes.func,
    translate: PropTypes.func,
};

export default withTranslate(SuggestionsSection);
